import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { StorageInstallationStatementModel } from '../../models'
import LabeledFieldDisplay from 'src/Libs/installation-statement/components/Overview/LabeledFieldDisplay'
import { getLocalizedNumber } from 'src/Libs/languages/functions/default'

interface Props {
  data: StorageInstallationStatementModel
}

/**
 * All information of the storage to be displayed in the overview section of the installation statement
 */
const Storage: React.VFC<Props> = ({ data }) => {
  const { t } = useCustomTranslation()

  return (
    <Stack spacing={2}>
      <Typography variant="h5">{t('installation-statement.storage.title')}</Typography>
      <Stack direction={{ xs: 'column', md: 'row' }} display="flex" justifyContent={'space-between'}>
        <Box sx={{ minWidth: '40%' }}>
          <Box sx={{ pb: 2 }}>
            <Box sx={{ pb: 2 }}>
              <Typography variant="caption">{t('installation-statement.storage.form.general.title')}</Typography>
            </Box>
            <LabeledFieldDisplay label={t('installation-statement.storage.form.general.connection-type')} dataField={data.connectionType} />
            <LabeledFieldDisplay label={t('installation-statement.storage.form.general.weather-conditions')} dataField={data.weatherConditions} />
            <LabeledFieldDisplay label={t('installation-statement.storage.form.general.temperature')} dataField={data.temperature} />
            <LabeledFieldDisplay label={t('installation-statement.storage.form.general.net-configuration')} dataField={data.netConfiguration} />
          </Box>
          <Box>
            <Box sx={{ pb: 2 }}>
              <Typography variant="caption">{t('installation-statement.storage.form.setup.title')}</Typography>
            </Box>
            <LabeledFieldDisplay label={t('installation-statement.storage.form.setup.wall-mounted')} dataField={data.wallMounted} />
            <LabeledFieldDisplay label={t('installation-statement.storage.form.setup.installation-type')} dataField={data.installationType} />
            <LabeledFieldDisplay label={t('installation-statement.storage.form.setup.application-area')} dataField={data.applicationArea} />
            <LabeledFieldDisplay label={t('installation-statement.storage.form.setup.emergency-option')} dataField={data.emergencyOption} />
          </Box>
        </Box>
        <Box sx={{ minWidth: '40%' }}>
          <Box sx={{ pb: 2 }}>
            <Typography variant="caption">{t('installation-statement.storage.form.distances.title')}</Typography>
          </Box>
          <LabeledFieldDisplay
            label={t('installation-statement.storage.form.distances.top')}
            dataField={data.distanceTop ? getLocalizedNumber(Number(data.distanceTop)) : null}
          />
          <LabeledFieldDisplay
            label={t('installation-statement.storage.form.distances.front')}
            dataField={data.distanceFront ? getLocalizedNumber(Number(data.distanceFront)) : null}
          />
          <LabeledFieldDisplay
            label={t('installation-statement.storage.form.distances.right')}
            dataField={data.distanceRight ? getLocalizedNumber(Number(data.distanceRight)) : null}
          />
          <LabeledFieldDisplay
            label={t('installation-statement.storage.form.distances.left')}
            dataField={data.distanceLeft ? getLocalizedNumber(Number(data.distanceLeft)) : null}
          />
        </Box>
      </Stack>
    </Stack>
  )
}
export default Storage
